import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IDatas, ISubsstationDatas } from "./sidebar.interface";

const initialState: IDatas = {
  Substation: {
    name: "",
    rid: "",
    mRID: "",
    type: "",
    schema: [],
    instance: {},
  },
  Bay: {
    name: "",
    rid: "",
    mRID: "",
    type: "",
    schema: [],
    instance: {},
  },

  EnergyConsumer: {
    name: "",
    rid: "",
    mRID: "",
    type: "",
    schema: [],
    instance: {},
  },
};

const sidebarSlice = createSlice({
  name: "sidebarSlice",
  initialState: initialState,
  reducers: {
    setAllDataByListItem: (state, action: PayloadAction<IDatas>) => {
      state.Substation = action?.payload?.Substation;
      state.Bay = action?.payload?.Bay;
      state.EnergyConsumer = action?.payload?.EnergyConsumer;
    },
    setSidebarConsumerItem: (state, action: PayloadAction<any>) => {
      state.EnergyConsumer = action?.payload;
    },
    setSidebarSubstationItem: (state, action: PayloadAction<any>) => {
      state.Substation = action?.payload;
    },
    setSidebarTransformerItem: (state, action: PayloadAction<any>) => {
      state.Bay = action?.payload;
    },
  },
});
export const {
  setAllDataByListItem,
  setSidebarConsumerItem,
  setSidebarSubstationItem,
  setSidebarTransformerItem,
} = sidebarSlice.actions;
export default sidebarSlice.reducer;
